<template>
	<main>
		<header class="mob-back-header">
			<img
				@click="checkAndRedirect()"
				class="mr-3"
				src="../../assets/mobile/assprog/mobileBackArrow.svg"
				alt=""
			/>{{ from == "Transaction" ? "Details" : "Job Details" }}
		</header>
		<section class="jobdetail-main-container w-100">
			<div class="h-100">
				<div
					class="mobjd-applied-top jobdetail-mob-white"
					:class="interviewData.interview.panelMeetingStatus == 0 && 'h-100'"
				>
					<Transaction />
				</div>
				<div
					v-if="
						interviewData.interview.panelMeetingStatus != 0 ||
						from == 'Transaction'
					"
					class="mobjd-applied-footer w-100 px-3"
				>
					<template v-if="interviewData.level != 2 || from == 'Transaction'">
						<div class="mob-cancelBtn w-50">
							<b-button
								class="w-100"
								@click="
									from == 'Transaction'
										? checkAndRedirect()
										: interviewData.level == 0
										? showAcceptRejectModal(false, interviewData.interview)
										: interviewData.level == 1 &&
										  interviewData.interview.timeRemaining == 'ongoing'
										? goToFeedback()
										: showCancelInterview(interviewData.interview, interviewData.interview.timeRemaining)
								"
								>{{
									from == "Transaction"
										? "Cancel"
										: interviewData.level == 0
										? "Reject"
										: interviewData.level == 1 &&
										  interviewData.interview.timeRemaining == "ongoing"
										? "Give Feedback"
										: "Cancel Meeting"
								}}</b-button
							>
						</div>
						<div class="mob-addBtn position-relative w-50">
							<b-button
								class="w-100"
								@click="
									from == 'Transaction'
										? reportIssues()
										: interviewData.level == 0
										? showAcceptRejectModal(true, interviewData.interview)
										: openMeetingLink(interviewData.interview.meetingLink)
								"
								>{{
									from == "Transaction"
										? "Report"
										: interviewData.level == 0
										? "Accept"
										: "Join Meeting"
								}}</b-button
							>
						</div>
					</template>
					<div v-else class="mob-addBtn position-relative w-50">
						<b-button
							class="w-100"
							@click="
								interviewData.interview.status == 2
									? viewFeedbackData(interviewData.interview)
									: goToFeedback()
							"
							>{{
								interviewData.interview.status == 2
									? "View Feedback"
									: "Give Feedback"
							}}</b-button
						>
					</div>
				</div>
			</div>
		</section>
		<ReportIssueModal
			v-if="showReportModal"
			:showModal="showReportModal"
			@closeReport="showReportModal = false"
			:reportIssue="reportIssue"
			:isTransaction="interviewData.transaction"
			:interviewId="interviewData.interview.interviewID"
		/>
		<AcceptRejectModal
			v-if="showAcceptReject || cancelInterview"
			:showAcceptReject="showAcceptReject || cancelInterview"
			:interview="selectedInterview"
			:type="actionType"
			:cancel="cancelInterview"
			@success="checkAndClose('success', $event), getAllPanelData()"
			@close-modal="checkAndClose('close')"
		/>
		<ViewFeedback
			v-if="showViewFeedback"
			:showViewFeedback="showViewFeedback"
			:interview="selectedInterview"
			@close-modal="hideViewFeedback()"
		/>
	</main>
</template>

<script>
import Transaction from "@/components/Transaction.vue";
import panelDashboardMixin from "@/components/mixin/panelDashboardMixin";
import { mapGetters } from "vuex";
import { openMeetingLink } from "@/components/PanelDasboard/panelHelpers";
import ReportIssueModal from "@/components/JobProgress/ReportIssueModal.vue";

export default {
	name: "JobDetailsMob",
	data() {
		return {
			from: this.$route.query.from,
			showReportModal: false,
			reportIssue: {
				1: "Payment not received",
				2: "Incorrect payment amount",
				3: "Delayed payment",
				4: "Others ",
			},
		};
	},
	mixins: [panelDashboardMixin],
	components: {
		Transaction,
		ReportIssueModal,
	},
	computed: {
		...mapGetters("candidateVUEX", {
			interviewData: "getInterview",
		}),
	},
	created() {
		if (this.$route.query.from == "TransactionMob") {
			this.from = "Transaction";
		}
	},
	methods: {
		reportIssues() {
			this.showReportModal = true;
		},
		checkAndRedirect() {
			if (this.$route.query.from && this.$route.query.level) {
				console.log("in hererre");
				let route = {
					name: this.$route.query.from,
					params: {
						level: this.$route.query.level,
					},
				};
				this.$router.push(route);
			} else {
				this.goToPanelDashboard();
			}
		},
		openMeetingLink(link) {
			openMeetingLink(link);
		},
		goToFeedback() {
			let basicInfo = {
				name: this.interviewData.interview.name,
				panelName: this.interviewData.interview.emailID,
				formID: this.interviewData.interview.interviewInfo.feedbackFormID,
				licenseKey: this.interviewData.interview.licenseKey,
				interviewID: this.interviewData.interview.interviewID,
			};
			this.$store.commit("candidateVUEX/setFeedbackData", basicInfo);
			let route = { name: "GiveFeedback", query: { from: "jobdetails" } };
			if (this.$route.query.from && this.$route.query.level) {
				(route.query.backto = this.$route.query.from),
					(route.query.level = this.$route.query.level);
			}
			this.$router.push(route);
		},
	},
};
</script>

<style>
.jobdetail-main-container {
	background-color: #e9ecef;
	height: calc(100dvh - (60px + env(safe-area-inset-top)));
	padding: 15px;
	overflow: auto;
}
.jobdetail-mob-white {
	background-color: #ffffff;
	padding: 15px;
}
</style>
